/** @jsx jsx */
import { jsx, Container } from 'theme-ui';
import { memo } from 'react';

// Types
import { SectionComponent } from '@codersclan/gatsby-theme-airfleet/src/@types';
import { Section } from '../../@codersclan/gatsby-theme-airfleet/@types/section';

// Components
import Text, { TEXT_TYPES } from '../../components/text';
import TextFrame from '../../components/textFrame';

interface PostPageTitleAndContentProps extends Section {
  postPage: {
    title: string;
    content: string;
  };
}

const PostPageTitleAndContent: SectionComponent<PostPageTitleAndContentProps> = memo(
  ({ postPage }) => (
    <Container
      sx={{ paddingY: ['10px', '25px'], paddingX: ['20px', 'revert'] }}
    >
      <Text type={TEXT_TYPES.H1_BOLD} sx={{ textAlign: 'center' }}>
        {postPage.title}
      </Text>
      <TextFrame content={postPage.content} />
    </Container>
  ),
);

export default PostPageTitleAndContent;
